// ##############################
//
//  Base Styles imherited from Material Dashbaord Pro and modified
//
// #############################

import * as MDPro from "../../material-dashboard/assets/jss/material-dashboard-pro-react.jsx";

const defaultFont = {
  fontFamily: '"BasisGrotesquePro-Regular", "Helvetica", "Arial", sans-serif',
  fontWeight: "300",
  lineHeight: "1.5em",
};

export const kickNavy = "#1e2347";
export const kickYellow = "#ffdd00";
export const kickPink = "#ffb7ad";
export const kickSlate = "#8096ab";
export const kickBlue = "#3f3f82";
export const kickGreen = "#30544f";
export const kickRed = "#f25930";
export const kickFreeGreen = "#58B023";
//
export const kickLightYellow = "#fff7e5";
export const kickLightPink = "#fff2f0";
export const kickLightSlate = "#f7fcff";
export const kickLightBlue = "#f4f2f9";
export const kickLightGreen = "#f2f9f7";
export const kickLightTan = "#f9f9f9";

export const kickAmaYellow = "#ffd814";
export const kickAmaOrange = "#ffa41c";

export const kickGray300 = "#f0f4ef";
export const kickGray150 = "#888";
//
// $kick-hero-green: #006e62 !default;

// const primaryColor = "#9c27b0";
// const warningColor = "#ff9800";
// const dangerColor = "#f44336";
// const successColor = "#4caf50";
// const infoColor = "#00acc1";
// const roseColor = "#e91e63";
// const grayColor = "#999999";
//
const primaryColor = "#3f3f82";
const warningColor = "#ff9800";
const dangerColor = "#f25930";
const successColor = "#4caf50";
const infoColor = "#00acc1";
const roseColor = "#e91e63";
const grayColor = "#999999";

const tooltip = {
  fontFamily: '"BasisGrotesque-Light",Helvetica,Arial,sans-serif',
};

const title = {
  fontFamily: "'Spectral', 'Helvetica', 'Arial', sans-serif",
  "& small": {},
};

const baseStyles = {
  ...MDPro,
  tooltip: { ...MDPro.tooltip, tooltip },
  title: { ...MDPro.title, title },
};

export default baseStyles;
